import React from 'react';
// LIBRARIES
import cx from 'classnames';
// STYLES
import './styles.scss';

const Button = ({ 
  text, 
  variant, 
  disabled, 
  children,
  buttonClassName,
  ...others
}) => (
  <button
    type="button"
    variant={variant}
    disabled={disabled}
    className={cx('theme-btn', buttonClassName)}
    {...others}
    >
    {text}
    {children}
  </button>
);


export default Button;
